import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Field} from 'redux-form';

import {
  FieldDiv,
  FieldRow,
  Label
} from './CheckoutPage.style';

import {
  validateEmail,
  validateRequired,
  validateTelephone
} from '../../helpers/formValidation.helper';
import {RenderTextInput} from '../../components/ReduxForm/RenderTextInput';

const ConsumerData = ({dataInitializedFromStorage}) => {
  return (
    <div>
      <FieldRow>
        <FieldDiv id="consumerName">
          <Label for="name">
            <FormattedMessage id="checkout.consumerName" />
            <Field
              id="name"
              name="name"
              type="text"
              maxLength="100"
              component={RenderTextInput}
              validate={[validateRequired]}
              dataInitializedFromStorage={dataInitializedFromStorage}
            />
          </Label>
        </FieldDiv>
        <FieldDiv
          nomargin
          id="consumerEmail"
        >
          <Label for="email">
            <FormattedMessage id="checkout.consumerEmail" />
            <small>
              <FormattedMessage id="checkout.consumerEmailNote" />
            </small>
            <Field
              id="email"
              name="email"
              type="email"
              maxLength="100"
              component={RenderTextInput}
              validate={[validateRequired, validateEmail]}
              dataInitializedFromStorage={dataInitializedFromStorage}
            />
          </Label>
        </FieldDiv>
      </FieldRow>
      <FieldRow>
        <FieldDiv
          nomargin
          id="consumerPhone"
        >
          <Label for="phone">
            <FormattedMessage id="checkout.consumerPhone" />
            <small>
              <FormattedMessage id="checkout.consumerPhoneNote" />
            </small>
            <Field
              id="phone"
              name="phone"
              type="tel"
              maxLength="30"
              component={RenderTextInput}
              validate={[validateRequired, validateTelephone]}
              dataInitializedFromStorage={dataInitializedFromStorage}
            />
          </Label>
        </FieldDiv>
      </FieldRow>
    </div>
  );
};

ConsumerData.propTypes = {
  dataInitializedFromStorage: PropTypes.bool.isRequired
};

export default ConsumerData;



// WEBPACK FOOTER //
// ./containers/CheckoutPage/ConsumerData.js